// src/App.js
import React, { useEffect, useMemo, Suspense, startTransition } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { RouterProvider } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
// import getTheme from './theme';
import { router } from './router';
import './app.scss';
import { AuthProvider } from './hooks/Services/AuthContext';
import { fetchCurrencies } from "./Store/actions/currencyActions";
import { setRates, setSymbols } from "./Store/reducers/currencyReducer";
import CookiePopup from './cookie/CookiePopup';
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';
import ThemeToggle from './ThemeToggle';
import getTheme from './theme';
function App() {
  const dispatch = useDispatch();
  const locale = useSelector((state) => state.language?.locale || "en");
  const allMessages = useSelector((state) => state.messages);
  // Locales other than pl/en are partial, so missing keys fall back to English.
  const messages = useMemo(
    () => ({ ...(allMessages?.en || {}), ...(allMessages?.[locale] || {}) }),
    [allMessages, locale]
  );
  // const theme = useMemo(() => getTheme(mode), [mode]);

  useEffect(() => {
    dispatch(fetchCurrencies());
  }, [dispatch]);

  useEffect(() => {
    const fetchRates = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/currencies?populate=*`);
        const json = await res.json();

        const ratesObj = {};
        const symbolsObj = {};
        if (json.data && Array.isArray(json.data)) {
          json.data.forEach((item) => {
            ratesObj[item.code] = item.rate;
            symbolsObj[item.code] = item.symbol;
          });
          startTransition(() => {
            dispatch(setRates(ratesObj));
            dispatch(setSymbols(symbolsObj));
          });
        }
      } catch (err) {
        console.error("Failed to fetch currency rates:", err);
      }
    };
    fetchRates();
  }, [dispatch]);

  return (
    <AuthProvider>
      <IntlProvider locale={locale} messages={messages}>
        {/* <ThemeProvider theme={theme}> */}
        <CssBaseline />   {/* important for consistent dark/light backgrounds */}
        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>Loading...</div>}>
          <AppContent />
        </Suspense>
        {/* </ThemeProvider> */}
      </IntlProvider>
    </AuthProvider>
  );
}

// const theme = createTheme({
//   colorSchemes: {
//     dark: true,
//     light: true
//   },
// });

function AppContent() {
  return (
    <>
      <RouterProvider router={router} />
      <CookiePopup />
    </>
  );
}

export default function ToggleColorMode() {
  return (
    // <ThemeProvider theme={theme}>
    <App />
    // </ThemeProvider>
  );
}

// export default App;
